import React from 'react'
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea, Chip, Link } from '@mui/material';

interface Props {
    title: string;
    subtitle: string;
    image: string;
    color: string;
    link: string;
}

const Cockpit: React.FC<Props> = ({ title, subtitle, image, color, link }) => {
    return (
            <Link href={link} target="_blank" rel="noopener" underline="none">
        <Card sx={{ display: 'flex' }}>
            <CardActionArea sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start', paddingLeft: 2, width: '100%' }}>
                <CardMedia
                    component="img"
                    sx={{ width: 64 }}
                    height="64"
                    width="64"
                    image={image}
                    alt={title}
                />
                <CardContent sx={{ width: '100%' }}>
                    <Typography gutterBottom variant="h6" sx={{ minWidth: 2 }}>
                        {title}
                    </Typography>
                    <Chip label={subtitle} sx={{ backgroundColor: `${color}`, color: 'white', border: 'Opx solid white' }} />
                </CardContent>
            </CardActionArea>
        </Card >
            </Link>
    )
}

export default Cockpit